module.exports = __webpack_public_path__ + "static/media/happy-house.f734543c.svg";